import { QueryAggregate, type ColumnAggregateInfo } from '@powerportalspro/core';
import { KanbanBoard } from '@powerportalspro/react-fluent';

// The open opportunities of the demo's sample data, a lane for each rating — Hot, Warm and Cold —
// with each lane's estimated revenue in its header.

// Dataverse's own "Open Opportunities" view, which every environment has under this id.
const OPEN_OPPORTUNITIES_VIEW_ID = '00000000-0000-0000-00aa-000010003001';

const totals: ColumnAggregateInfo[] = [{ columnName: 'estimatedvalue', aggregates: [{ aggregate: QueryAggregate.Sum }] }];

export function KanbanBoardMainSample() {
  return (
    <KanbanBoard
      defaultViewId={OPEN_OPPORTUNITIES_VIEW_ID}
      laneColumn="opportunityratingcode"
      lanes={['1', '2', '3']}
      laneAggregates={totals}
      laneAggregateFormats={{ estimatedvalue: 'C0' }}
      height="560px"
    />
  );
}
